"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsrLoggerSymbol = void 0;
exports.SsrLoggerSymbol = Symbol('SsrLogger');
//# sourceMappingURL=ssrLogger.js.map